import { useCallback } from 'react';
import { useNavComponentManager } from './useNavComponentManager';
export const useOnFunctionCalled = __definition => {
  const {
    addFunctionSubscriber,
    removeFunctionSubscriber
  } = useNavComponentManager();
  const registerCallback = useCallback((fnName, subscriber) => {
    addFunctionSubscriber(fnName, subscriber);
    return () => removeFunctionSubscriber(fnName, subscriber);
  }, [addFunctionSubscriber, removeFunctionSubscriber]);
  return {
    registerCallback
  };
};